export default __webpack_public_path__ + "static/media/info-section.e9dd329a.svg";